export const COMPARTMENTS_REQUEST = "COMPARTMENTS_REQUEST";
export const COMPARTMENTS_SUCCESS = "COMPARTMENTS_SUCCESS";
export const COMPARTMENTS_ERROR = "COMPARTMENTS_ERROR";
export const COMPARTMENTS_CLEAR = "COMPARTMENTS_CLEAR";
export const COMPARTMENTS_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'CompartmentsV1',
    filter: []
};

export const POSTCOMPARTMENTS_REQUEST = "POSTCOMPARTMENTS_REQUEST";
export const POSTCOMPARTMENTS_SUCCESS = "POSTCOMPARTMENTS_SUCCESS";
export const POSTCOMPARTMENTS_ERROR = "POSTCOMPARTMENTS_ERROR";
export const POSTCOMPARTMENTS_CLEAR = "POSTCOMPARTMENTS_CLEAR";
export const POSTCOMPARTMENTS_params = {
    key: process.env.VUE_APP_API_KEY2,
};
